const KsUser = 'userInfo';

export const userInfo = cb => {
    __ksStorage__.getBaseInfo(KsUser, data => {
        if (data) {
            // 为了做兼容性
            _.extend(data, data.user || data.sub_user);
        }
        cb && cb(data);
    });
};

export const isKA = () => {
    return new Promise((resolve, reject) => {
        userInfo(data => {
            if (data && typeof data.is_ka === 'boolean') {
                resolve(data.is_ka)
            } else {
                reject('获取用户类型失败')
            }
        });
    });
}
